// utils/scormApi.js
// ──────────────────────────────────────────────────────────────────────────────
// SCORM 1.2 / 2004 / xAPI runtime + admin API helpers.
// ──────────────────────────────────────────────────────────────────────────────

import apiClient from './apiClient';

const BASE = '/scorm';

// ── Admin ────────────────────────────────────────────────────────────────────
export const uploadScormPackage = (formData, opts = {}) =>
  apiClient.post(`${BASE}/admin/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: opts.onUploadProgress,
  });

export const reextractScormPackage = (lessonId) =>
  apiClient.post(`${BASE}/admin/lessons/${lessonId}/reextract`);

export const replaceScormPackage = (lessonId, formData, opts = {}) =>
  apiClient.post(`${BASE}/admin/lessons/${lessonId}/replace-package`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: opts.onUploadProgress,
  });

export const getScormStatus = (lessonId) =>
  apiClient.get(`${BASE}/admin/lessons/${lessonId}/status`);

// ── Reporting (admin) ─────────────────────────────────────────────────────────
export const getScormReport = (lessonId) =>
  apiClient.get(`${BASE}/admin/lessons/${lessonId}/report`);

export const getScormAttemptDetail = (attemptId) =>
  apiClient.get(`${BASE}/admin/attempts/${attemptId}/detail`);

export const downloadScormReportCsv = (lessonId) =>
  apiClient.get(`${BASE}/admin/lessons/${lessonId}/report.csv`, { responseType: 'blob' });

// ── Runtime ──────────────────────────────────────────────────────────────────
export const getScormLaunchInfo = (lessonId) =>
  apiClient.get(`${BASE}/lessons/${lessonId}/launch`);

export const startScormAttempt = (lessonId, opts = {}) =>
  apiClient.post(`${BASE}/attempt/start`, {
    lessonId,
    // Optional for multi-SCO packages. When omitted the BE picks the first SCO.
    ...(opts.activityId ? { activityId: opts.activityId } : {}),
    // restart:true forces a brand-new attempt (Retake) instead of resuming.
    ...(opts.restart ? { restart: true } : {}),
  });

export const commitScormCmi = (attemptId, body) =>
  apiClient.post(`${BASE}/attempt/${attemptId}/commit`, body);

export const finishScormAttempt = (attemptId, body) =>
  apiClient.post(`${BASE}/attempt/${attemptId}/finish`, body);

// Build a relative asset URL (for use in iframe src or anchors). The browser
// will follow the 302 redirect to a presigned R2 URL automatically.
export const scormAssetUrl = (lessonId, relPath) => {
  // apiClient has a baseURL — let the absolute path resolve against it.
  const base = apiClient.defaults.baseURL || '';
  return `${base.replace(/\/$/, '')}${BASE}/assets/${lessonId}/${String(relPath).replace(/^\/+/, '')}`;
};
